class PlaceholderTypewriter {
  constructor(input) {
    this.input = input;
    this.typingSpeed = 40;

    this.placeholders = [
      input.placeholder,
      input.dataset.secondPlaceholder,
      input.dataset.thirdPlaceholder,
      input.dataset.fourthPlaceholder,
    ].filter(Boolean);
  }

  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async typeText(target) {
    let current = this.input.getAttribute('placeholder') || '';

    const remaining =
      current.length >= 3 && target.startsWith(current)
        ? target.slice(current.length)
        : target;

    for (const char of remaining) {
      current += char;
      this.input.setAttribute('placeholder', current);
      await this.wait(this.typingSpeed);
    }
  }

  async deleteText(nextTarget) {
    let current = this.input.getAttribute('placeholder') || '';

    while (
      current.length > 0 &&
      !(current.length >= 3 && nextTarget.startsWith(current))
    ) {
      current = current.slice(0, -1);
      this.input.setAttribute('placeholder', current);
      await this.wait(this.typingSpeed * 0.75);
    }
  }

  async start() {
    if (!this.placeholders.length) return;

    await this.wait(2000);

    let index = 0;

    while (true) {
      const next =
        this.placeholders[(index + 1) % this.placeholders.length];

      index = (index + 1) % this.placeholders.length;

      await this.deleteText(next);
      await this.wait(400);

      await this.typeText(next);
      await this.wait(3000);
    }
  }
}

class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (!this.input) return;

    this.input.form.addEventListener(
      'reset',
      this.onFormReset.bind(this)
    );

    const shouldAnimate =
      (
        this.input.dataset.secondPlaceholder ||
        this.input.dataset.thirdPlaceholder ||
        this.input.dataset.fourthPlaceholder
      ) &&
      (
        this.input.dataset.animatedPlaceholderMob === 'true' ||
        !window.matchMedia('(max-width: 749.98px)').matches
      );

    if (shouldAnimate) {
      new PlaceholderTypewriter(this.input).start();
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event?.preventDefault();

    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
    }
  }
}

customElements.define('search-form', SearchForm);

